<template>

    <SubHeader title="Fiche Affectation" :breads="[{ name: 'Créer Affection' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(data)">

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" id="label" v-model="data.label" class="form-control" placeholder="Motif"
                                        value="">
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Message de notification (version Mail)</label>
                                    <textarea class="form-control" id="label"  v-model="data.message"  name="label" rows="4" cols="50" value=""></textarea>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Message de notification (version SMS)</label>
                                    <textarea class="form-control" id="label"  v-model="data.sms"  name="label" rows="4" cols="50" value=""></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigCreateAffectation",
    components: {
        SubHeader
    },
    data(){
        return {
            data:{}
        }
    },
    computed: {
        ...mapFields("affectation/create", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items",
            isCreated:"isCreated"

        }),
    },
    methods:{
        ...mapActions({
            handleSubmit:"affectation/create/create",
            reset:"affectation/create/resetData"
        })
    },
    watch:{
        isCreated(val){
            if(val){
                this.$router.push({name:"AdminConfigAffectation"})
            }
        }
    },
    unmounted(){
        this.reset()
    }
}
</script>
